
/* global Infinity */

function scaleExtent(domain) {
  var start = domain[0], stop = domain[domain.length - 1];
  return start < stop ? [start, stop] : [stop, start];
}

function linearTickRange(extent, m) {
  if (m == null)
    m = 10;

  var span = extent[1] - extent[0],
          step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)),
          err = m / span * step;

  // Filter ticks to get closer to the desired count.
  if (err <= .15)
    step *= 10;
  else if (err <= .35)
    step *= 5;
  else if (err <= .75)
    step *= 2;

  // Round start and stop values to step interval.
  extent[0] = Math.ceil(extent[0] / step) * step;
  extent[1] = Math.floor(extent[1] / step) * step + step * .5; // inclusive
  extent[2] = step;
  return extent;
}

function range(start, stop, step) {
  if (arguments.length < 3) {
    step = 1;
    if (arguments.length < 2) {
      stop = start;
      start = 0;
    }
  }
  if ((stop - start) / step === Infinity)
    throw new Error("infinite range");
  var range = [],
          k = integerScale(Math.abs(step)),
          i = -1,
          j;
  start *= k,
          stop *= k,
          step *= k;
  if (step < 0)
    while ((j = start + step * ++i) > stop)
      range.push(j / k);
  else
    while ((j = start + step * ++i) < stop)
      range.push(j / k);
  return range;
}

function integerScale(x) {
  var k = 1;
  while (x * k % 1)
    k *= 10;
  return k;
}


export default function niceRange(domain, m) {
  domain = scaleExtent(domain);
  
  let przesun = 0;
  if (domain[0] < 0) {
    const min = domain[0];
    domain[0] = 0;
    domain[1] = domain[1] - min;
    przesun = Math.floor(min);
  }

  const ra = linearTickRange(domain, m);
  if (przesun !== 0) {
    ra[0] = ra[0] + przesun;
    ra[1] = ra[1] + przesun;
  }
  
  return range(...ra);
}



// WEBPACK FOOTER //
// ./src/utils/niceRange.js